import { useState, useEffect } from "react";
import {
  TabContainer,
  ThankyouHeader,
  ThankyouMessage,
} from "../../components/SocialCaseTbas/Social.styled";
import { ComplaintContainer, Label } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import thanks from "../../assets/thanks.svg";
import complaintAndLinkStore from "../../stores/ComplaintAndLinkStore";
import HappyMeterStore from "../../stores/HappyMeter";
import User from "../../stores/UserStore";

import General from "../../stores/GeneralStore";
import { useNavigate } from "react-router-dom";
const LinkProperty = () => {
  const [thankyou, setThankyou] = useState(false);
  const [parcelNumber, setParcelNumber] = useState<string>('');
  const [accounts, setAccounts] = useState<{ sewerageId: string }[]>([]);

  const handleContinue = async () => {
    complaintAndLinkStore.delinkAccount(
      {
        errorId: 'delinkAccountError',
        data: parcelNumber
      })
    setThankyou(true);
    HappyMeterStore.openHappinessMeter();
    HappyMeterStore.setUPserviceID("11");
  }

  //TODO: check this function returning await
  useEffect(() => {
    const asyncUseEffect = async () => {
      let response = await complaintAndLinkStore.connectedAccounts({ errorId: "connectedAccountsError" });
      if (response.result.accounts.length) {
        setParcelNumber(response.result.accounts[0].sewerageId);
        setAccounts(response.result.accounts);
      }
    }
    asyncUseEffect();
  }, []);
const navigate=useNavigate()
const contrast = General?.contrast;

  return (
    <>
      <MoveInHeader
        style={{ background: "#62aa51", height: "10em", paddingTop: "1rem" }}
      >
        <div style={{ width: "80%", margin: "auto" }}>
          <MiniNav>
            <ButtonSecondary
              style={{
                background: "transparent",
                color: "#fff",
                width: "15%",
                borderColor: "#fff",
              }}
              onClick={() =>
                navigate("/dashboard")
              }
            >
              BACK
            </ButtonSecondary>
          {!User?.info?.personId&& <ButtonSecondary
              style={{
                background: "transparent",
                color: "#fff",
                width:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "12rem":"117px",
                borderColor: "#fff",
              }}
              onClick={() => navigate("/dashboard")}
            >
              {General?.codeLabels["cm_dashboard"]?.label !== undefined ? General?.codeLabels["cm_dashboard"]?.label : "DASHBOARD"}

            </ButtonSecondary>}
          </MiniNav>
          <h1>De-Link Property</h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          minHeight: thankyou ? "" : "60vh",
          marginTop: thankyou ? "1rem" : "auto",
        }}
      >
        {!thankyou && (
          <TabContainer style={{ width: "90%", paddingTop: "2rem" }}>
            {" "}
            <Label style={{ fontWeight: "800" }}>
              {General?.codeLabels["cm_enterparcel"]?.label !== undefined ? General?.codeLabels["cm_enterparcel"]?.label : "Parcel Number"}*
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  gap: "1rem",
                }}
              >
                <select value={parcelNumber} onChange={(e) => setParcelNumber(e.target.value)}>
                  {accounts.map((account, index) => (
                    <option value={account.sewerageId} key={index}>
                      {account.sewerageId}
                    </option>
                  ))}
                </select>
              </div>
            </Label>

            <hr style={{ gridColumn: "1 / span 2", width: "100%" }} />
            <ButtonSecondary
              style={{
                background: "#101e8e",
                color: "#fff",
                width: "60%",
                padding: "10px 0",
              }}
              disabled={parcelNumber === ''}
              onClick={handleContinue}
            >
              {General?.codeLabels["cm_continue"]?.label !== undefined ? General?.codeLabels["cm_continue"]?.label : "Continue"}

            </ButtonSecondary>
          </TabContainer>
        )}
        {thankyou && (
          <TabContainer
            style={{
              width:General?.isLargeScreen?'50%': "100%",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              alignSelf: "flex-start",
              minHeight: "50vh",
              gap: "0",
              background:contrast?.contrastBackground?contrast?.contrastBackground:'white'
            }}
          >
            <ThankyouHeader>
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                 <path d="M23 0C10.317 0 0 10.317 0 23C0 35.683 10.317 46 23 46C35.683 46 46 35.683 46 23C46 18.44 44.6603 14.1893 42.3633 10.6113L40.9941 12.2285C42.8891 15.3825 44 19.06 44 23C44 34.579 34.579 44 23 44C11.421 44 2 34.579 2 23C2 11.421 11.421 2 23 2C28.443 2 33.3939 4.09977 37.1289 7.50977L38.4375 5.96484C34.3525 2.25984 28.935 0 23 0ZM41.2363 5.75391L21.9141 28.5547L13.7812 20.9688L12.418 22.4316L22.084 31.4473L42.7637 7.04688L41.2363 5.75391Z"
                fill={General?.colorClass?General?.colorClass:"#62AA51"}/>
              </svg>
              <h1>                          {General?.codeLabels["cm_thankyou"]?.label !== undefined ? General?.codeLabels["cm_thankyou"]?.label : "Thank you !!!"}
              </h1>
            </ThankyouHeader>
            <ThankyouMessage>
              <p>Account is successfully De-linked with portal</p>
              <p>
                <b>             
                   {General?.codeLabels["cm_seweragenum"]?.label !== undefined ? General?.codeLabels["cm_seweragenum"]?.label : "Sewerage Number"}
                </b>
              </p>
              <h4>{parcelNumber}</h4>
              <ButtonSecondary onClick={()=>navigate('/dashboard')} style={{ background: "#101e8e", color: "#fff" }}>
                BACK TO MY Dashboard
              </ButtonSecondary>
            </ThankyouMessage>
          </TabContainer>
        )}
      </ComplaintContainer>
    </>
  );
};

export default LinkProperty;
